module.exports = __webpack_public_path__ + "assets/e_mastercard-a84985.svg";